import { FC } from 'react';
import { asErrorMsg } from '../api';
import { useAccountContext } from '../context/AccountContext';
import ErrorMessage from './ErrorMessage';

/**
 * Error shown when the `AccountContext` lookup fails (`loadingState === 'error'`),
 * including the underlying error to help with debugging.
 */
export const AccountErrorMessage: FC = () => {
  const { accountError } = useAccountContext();
  return (
    <ErrorMessage
      error={
        accountError
          ? asErrorMsg(accountError)
          : 'Unable to retrieve account information.'
      }
    />
  );
};
